import { createAsyncAction } from 'typesafe-actions'
import { CreateOrderRequestDto, CreateOrderResponseDto } from '@sparling/financial-common'

export const {
  request: createOrderRequest,
  success: createOrderSuccess,
  failure: createOrderFailure,
} = createAsyncAction('CREATE_ORDER_REQUEST', 'CREATE_ORDER_SUCCESS', 'CREATE_ORDER_FAILURE')<
  CreateOrderRequestDto,
  CreateOrderResponseDto,
  Error
>()
